/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEdit } from "@fortawesome/fontawesome-free-solid"; // Edit icon added
import { Entry } from "../../redux/entrySlice";
import TextInput from "../../components/TextField/TextField";
import MultipleFileUpload from "../../components/MultipleFileUpload/MultipleFileUpload";
import styles from "./editCategoryPopup.module.scss";
import "react-toastify/dist/ReactToastify.css";
import { TableContext } from "../../contexts/tableContext";
import { Image } from "react-bootstrap";
import { HexColorPicker } from "react-colorful";
import togglestyles from "../../components/ToggleButton/ToggleButton.module.scss";
import NumberInput from "../../components/NumberBox/NumberBox";
import Loader from '../../components/Loader/Loader';

const EditCategoryPopup = React.memo(
  ({ categoryId, handleClose, setIsUpdated, edit = true }) => {
    const dispatch = useDispatch();
    const { files } = useContext(TableContext);
    const {
      control,
      register,
      handleSubmit,
      formState: { errors },
      reset,
    } = useForm();

    const [user, setUser] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false); // State for edit/view mode
    const [color, setColor] = useState();
    const [isOff, setIsOff] = useState();
    const [isMerOff, setIsMerOff] = useState();

    useEffect(() => {
      const actionData = {
        actionUrl: `category/${categoryId}`,
        actionMethod: "get",
      };

      dispatch(Entry(actionData)).then((resp) => {
        if (resp.payload.data.category) {
          setUser(resp.payload.data.category);
          reset(resp.payload.data.category);
        }
      });
    }, [categoryId, dispatch, reset]);

    const onSubmitData = (data) => {
      // if (!color) {
      //   toast.error("Color is required");
      //   return;
      // }
      setSubmitting(true);
      setError(null);
      const apiData = {
        category: data.category,
        // taxcode: data.taxcode ? data.taxcode : null,
        // order: parseInt(data?.order, 10),
        // color: color,
        // foodItem: isOff,
        // merchandise: isMerOff,
        // File: files,
      };
      data.actionUrl = `category/${categoryId}`;
      data.actionMethod = "patch";
      data.apiData = apiData;

      dispatch(Entry(data)).then((resp) => {
        setSubmitting(false);
        if (resp.payload.code === 200) {
          toast.success("Category updated successfully");
          setIsEditing(false); // Switch back to view mode after update
          handleClose();
          setIsUpdated((prev) => !prev);
        } else {
          setError(resp.payload.message);
          toast.error(resp.payload.message);
        }
      });
    };

    const toggleEditMode = () => {
      setIsEditing(!isEditing); // Toggle between edit and view modes
    };

    const handleButtonClick = () => {
      setIsOff(!isOff);
    };

    return (
      <div className={styles.popupbox}>
        <div className={styles.box}>
          {/* Flex container for close button, heading, and edit button */}

          <div className="d-flex align-items-center gap-3">
            <button
              className={styles.closeicon}
              aria-label="Close"
              onClick={handleClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            {/* Conditionally render the heading based on isEditMode */}
            <h2 className={styles.heading}>
              {isEditing ? "Edit Category Details" : "Category Details"}
            </h2>

            {/* Show edit button only when not in edit mode */}
            {!isEditing && edit && (
              <button
                type="button"
                className={`${styles.formbtnedit} d-flex align-items-center`}
                onClick={toggleEditMode}
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ color: "white", marginRight: "5px" }}
                />
                <span style={{ color: "white" }}>Edit</span>
              </button>
            )}
          </div>

          {/* Form Section */}
          <div className="container-fluid editdrinktypeform">
            {user ? (
              <form onSubmit={handleSubmit(onSubmitData)}>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-md-6">
                    <TextInput
                      className={styles.inputbox}
                      label="Category"
                      fieldName="category"
                      placeHolder="Enter Category"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      maxLength="50"
                      defaultValue={user.type}
                      readOnly={!isEditing}
                    />
                    {/* <NumberInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      labelstyle={styles.formlabel}
                      label="Priority"
                      placeHolder="Enter Priority (e.g., 1 for highest)"
                      fieldName="order"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      readOnly={!isEditing}
                    /> */}
                  </div>

                  {/* Right Column */}
                  {/* <div className="col-md-6">
                    <TextInput
                      className={styles.inputbox}
                      label="Order"
                      fieldName="order"
                      placeHolder="Enter Order (e.g., 1 for highest)"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      type="number"
                      min="1"
                    />
                    <label className={styles.formlabel}>Food Item</label>
                    <div className="d-flex align-items-center">
                      <label className={togglestyles.switch}>
                        <input
                          type="checkbox"
                          checked={isOff}
                          onClick={handleButtonClick}
                          disabled={!isEditing}
                        />
                        <span className={togglestyles.slider} />
                      </label>
                    </div>
                  </div> */}

                  {/* Color Picker and File Upload */}
                  {/* <div className="col-md-6">
                    {isEditing ? (
                      <>
                        <span>Color:</span>
                        <input
                          value={color}
                          onChange={(e) => setColor(e.target.value)}
                        />
                        <div style={{ margin: "5px" }}>
                          <HexColorPicker color={color} onChange={setColor} />
                        </div>
                      </>
                    ) : (
                      <TextInput
                        className={styles.inputbox}
                        label="Color"
                        fieldName="color"
                        placeHolder="Choose a color"
                        register={register}
                        errors={errors}
                        isRequired
                        mandatory
                        readOnly={!isEditing}
                      />
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className={styles.formlabel}>Merchandise</label>
                    <div className="d-flex align-items-center">
                      <label className={togglestyles.switch}>
                        <input
                          type="checkbox"
                          checked={isMerOff}
                          onClick={() => setIsMerOff(!isMerOff)}
                          disabled={!isEditing}
                        />
                        <span className={togglestyles.slider} />
                      </label>
                    </div>
                  </div> */}

                  {/* File Upload (Only in edit mode) */}
                  {/* {isEditing && (
                    <div className="col-md-6">
                      <MultipleFileUpload
                        editFiles={[user?.image]}
                        section="drinktype"
                        disabled={!isEditing}
                        register={register}
                        errors={errors}
                      />
                    </div>
                  )} */}
                </div>

                {/* Update Button (Only in edit mode) */}
                {isEditing && (
                  <div className="row mt-3">
                    <div className="col text-center">
                      <input
                        className={styles.formbtn}
                        type="submit"
                        disabled={submitting}
                        value={submitting ? "Please wait.." : "Update"}
                      />
                    </div>
                  </div>
                )}

                {error && <h6 className={styles.errormsg}>{error}</h6>}
              </form>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "130px",
                  color: "#39979d",
                }}
              >
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default EditCategoryPopup;
